import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useField } from '@unform/core'

function Input({ id, label, name, children, ...props }) {
  const inputRef = useRef(null);
  const { fieldName, registerField, defaultValue } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value'
    })
  }, [fieldName, registerField]);

  return (
    <div className="form-check form-check-inline">
      <input ref={inputRef}
        className="form-check-input"
        type="radio"
        id={id}
        name={name}
        defaultValue={defaultValue} {...props} />
      {label && <label className="form-check-label" htmlFor={id}>{label}</label>}
    </div>
  )
}

Input.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  name: PropTypes.string.isRequired
}

export default Input;